import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import axios from "axios"


import { QUOTES } from "../../../../Utilities/APIs"
import CRUDTable from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable"
import CRUDTableHeader from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader"
import CRUDth from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth"
import CRUDTableRow from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow"
import ShortTextCell from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell"
import ViewButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton"
import Modal from "../../../Partials/Elements/Modal/Modal"
import CRUDDeleteBoilerPlate from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDeleteBoilerPlate/CRUDDeleteBoilerPlate"
import CRUDButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/CRUDButton"

import { RiCheckFill } from "react-icons/ri"
import ViewQoute from "../ViewQoute"
import AcceptedRequest from "./AcceptedRequest"


function PendingRequest() {

    const [pendingQoutes, setPendingQoutes] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [targetID, setTargetID] = useState(null)
    const [showViewSection, setShowViewSection] = useState(false)
    const [showCreateForm, setShowCreateForm] = useState(false)
    const [showUpdateForm, setShowUpdateForm] = useState(false)
    const [showDeleteSection, setShowDeleteSection] = useState(false)
    const [showPendingQoutes, setShowPendingQoutes] = useState(false)

    const [toggleFetch, setToggleFetch] = useState(false)

    const { employee } = useSelector(state => state.auth)


    useEffect(() => {
        async function fetchAndSetPendingQoutes() {
            const { data } = await axios.get(QUOTES + 'getQuotesForAdmin/pending')
            setPendingQoutes(data)
        }

        fetchAndSetPendingQoutes()

    }, [toggleFetch])

    function handleClose() {
        setShowModal(false);
        setShowCreateForm(false);
        setShowViewSection(false);
        setShowUpdateForm(false);
        setShowDeleteSection(false);
        setShowPendingQoutes(false)
    }
    function triggerFetch() {
        setToggleFetch(prevState => !prevState)
    }
    return (
        <>
            <div className='crud_holder'>
                <div className="body_header">
                    <h1 className="heading">{`Pending Qoutes (${pendingQoutes?.length} in total)`}</h1>
                
                </div>
                <CRUDTable>
                    <CRUDTableHeader>
                        <CRUDth th='Name' />
                        <CRUDth th='Phone' />
                        <CRUDth th='Email' />
                        <CRUDth th='Actions' />
                    </CRUDTableHeader>
                    <tbody>
                        {pendingQoutes?.map(pendingQoute => (

                            <CRUDTableRow key={pendingQoute._id}>
                                <ShortTextCell text={pendingQoute?.name} />
                                <ShortTextCell text={pendingQoute?.phone} />
                                <ShortTextCell text={pendingQoute?.email} />
                                <td className="action_button_cell">
                                    <ViewButton
                                        setShowModal={setShowModal}
                                        setShowViewSection={setShowViewSection}
                                        targetID={pendingQoute._id}
                                        setTargetID={setTargetID}
                                    />
                                    

                                    <CRUDButton
                                        handleClick={() => {
                                            setShowModal(true)
                                            setShowPendingQoutes(true)
                                            setTargetID(pendingQoute._id)

                                        }}
                                    >
                                        <RiCheckFill />
                                    </CRUDButton>

                                  

                                </td>
                            </CRUDTableRow>
                        ))}
                    </tbody>
                </CRUDTable>
            </div>
            {showModal &&
                <Modal
                    handleClose={handleClose}
                    modalHeading={
                        (showCreateForm && `Create Request`) ||
                        (showUpdateForm && `Update  Request`) ||
                        (showDeleteSection && `Delete  Request`)
                    }
                >
                    
                    {
                        showDeleteSection &&
                        <CRUDDeleteBoilerPlate
                            api={QUOTES}
                            targetID={targetID}
                            employee={employee}
                            setShowModal={setShowModal}
                            setShowDeleteSection={setShowDeleteSection}
                            hasName
                            triggerFetch={triggerFetch}
                        />
                    }
                </Modal>
            }

            {showModal && showViewSection &&
                <Modal
                    view
                    handleClose={handleClose}
                    modalHeading={
                        (showViewSection && `View Request`)
                    }
                >
                    <ViewQoute
                        targetID={targetID}
                        employee={employee}
                    />
                </Modal>
            }
            {showModal && showPendingQoutes &&
                <Modal
                    handleClose={handleClose}
                    modalHeading={
                        (showPendingQoutes && `Pending Request`)
                    }
                >
                    <AcceptedRequest
                        targetID={targetID}
                        employee={employee}
                        setShowModal={setShowModal}
                        setShowPendingSection={setShowPendingQoutes}
                        triggerFetch={triggerFetch}
                    />
                </Modal>
            }

        </>
    )
}

export default PendingRequest